import { BrowserAuthOptions, BrowserSystemOptions, CacheOptions, Configuration } from '@azure/msal-browser';
import { BrowserTelemetryOptions } from '@azure/msal-browser/dist/config/Configuration';

export abstract class B2cConfig implements Configuration {
  auth!: BrowserAuthOptions;
  cache?: CacheOptions | undefined;
  system?: BrowserSystemOptions | undefined;
  telemetry?: BrowserTelemetryOptions | undefined;
  b2cApiScope!: string;
  b2cNewApiScope?: string;
  b2cScopes!: string[];
}
